'use client'

import Link from 'next/link'
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

interface MobileNavAccordionSection {
  title?: string
  items: any[]
  getItemId: (item: any) => string
  getItemName: (item: any) => string
  getItemUrl: (item: any) => string
  limit?: number
}

interface MobileNavAccordionProps {
  value: string
  triggerLabel: string
  sections: MobileNavAccordionSection[]
  viewAllUrl?: string
  viewAllText?: string
  onLinkClick?: () => void
}

const MobileNavAccordion = ({
  value,
  triggerLabel,
  sections,
  viewAllUrl,
  viewAllText = 'View All →',
  onLinkClick,
}: MobileNavAccordionProps) => {
  return (
    <AccordionItem value={value} className="border-t border-gray-100 px-5">
      <AccordionTrigger className="text-label-sm leading-6 text-gray-800 py-3 hover:no-underline">
        {triggerLabel}
      </AccordionTrigger>
      <AccordionContent>
        <div className="grid gap-1 pb-2">
          {sections.map((section, sectionIndex) => (
            <div key={section.title || sectionIndex}>
              {section.title && (
                <p className={`text-label-xs text-gray-500 font-semibold mb-1 ${sectionIndex > 0 ? 'mt-2' : ''}`}>
                  {section.title}
                </p>
              )}
              {section.items?.slice(0, section.limit || 8)?.map((item) => (
                <Link
                  key={section.getItemId(item)}
                  href={section.getItemUrl(item)}
                  className="block py-2 px-3 rounded-md hover:bg-gray-50 text-body-sm text-gray-700"
                  onClick={onLinkClick}
                >
                  {section.getItemName(item)}
                </Link>
              ))}
            </div>
          ))}
          {viewAllUrl && (
            <Link
              href={viewAllUrl}
              className="block py-2 px-3 rounded-md hover:bg-gray-50 text-label-sm text-primary-600 font-medium"
              onClick={onLinkClick}
            >
              {viewAllText}
            </Link>
          )}
        </div>
      </AccordionContent>
    </AccordionItem>
  )
}

export default MobileNavAccordion
